import { configureStore } from "@reduxjs/toolkit";
import { loaderSlice } from "./slice/loaderSlice";
import { toastSlice } from "./slice/toastSlice";

export const store = configureStore({
    reducer:{
        loader: loaderSlice.reducer,
        toast:toastSlice.reducer
    }
})